import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SITE_NAME = "Groupe DLA";
const baseUrl = (process.env.REACT_APP_SITE_URL || "").replace(/\/$/, "");
const ogImage = (process.env.REACT_APP_OG_IMAGE_URL || "").trim();

/**
 * @param {{ title: string; description: string; path?: string; robots?: string; omitCanonical?: boolean }} props
 */
export function PageMeta({ title, description, path = "", robots = "index, follow", omitCanonical = false }) {
  const { i18n } = useTranslation();
  const lang = i18n.language.startsWith('en') ? 'en' : 'fr';
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const canonical =
    !omitCanonical && baseUrl
      ? `${baseUrl}${path.startsWith("/") ? path : `/${path}`}`
      : undefined;

  return (
    <Helmet prioritizeSeoTags>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}

      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}

      <meta name="robots" content={robots} />
    </Helmet>
  );
}
